
export default ($input) => {
    $input.autocomplete({
        titleKey: 'title',
        valueKey: 'value',
        source:[
            function( q,add ){
                
                if(q.length == 4){
                    $.ajax({
                        url: "/Locality/Search?q="+encodeURIComponent(q),
                        dataType: 'json',
                        async: false,
                
                        success: function(resp) {
                            var collection = [];
                   
                            resp.forEach(function (item) {
                                collection.push({ title: item.postcode + " (" + item.title + ", " + item.state + ")", value: item.postcode, suburb: item.title, state: item.state  });
                            });
                            //console.log("x", collection.length)
                            add(collection)
                        }
                    });
                }
            }
        ],
        valid: ({ title, value }, query) => (
          query != "" && value.indexOf(query) === 0
        ),
        filter: function filter(items, query) 
        {
   

        return items.reduce((collection, item) => {
            if (this.valid(item, query)) {
                collection.push(item);
            }


            //remove duplicates because this library wont let us replace items (only add) after ajax load
            return collection.filter((obj, pos, arr) => {
                     return arr.map(mapObj => mapObj["title"]).indexOf(obj["title"]) === pos;
              });
        }, []);
       
     },
        minLength: 1,
        visibleLimit: 5.4,
        autoselect: true,
        showHint:false,
        limit: 101
    }).on('selected.xdsoft', (e, { suburb, state }) => {

        var form = $input.closest('form');
        let suburbElement = form.find('input[name="suburb"]')[0];
        suburbElement.value = suburb;
        suburbElement.dispatchEvent(new Event('change', { bubbles: true }));
        $(".suburb-foot", form).text(suburb + ", " + state); 
    });
    return $input;
};

